/* eslint eqeqeq: off */
import React from "react";
import Modal, {ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import {connect} from "react-redux";
import Hospital from "../../../Server/Hospital";
import Input from "../../../Components/Control/Input";
import PropTypes from "prop-types";
import moment from "jalali-moment";
import Radio from "../../../Components/Control/Radio";
import Select from "../../../Components/Control/Select";
import ValidationSpot from "../../../Components/Control/ValidationSpot";
import Separator from "../../../Components/Control/Separator";
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import Perms from '../../../Perms';
import MyComponent from '../../../Components/MyComponent';

class ModalHospitalOutgoingCancel extends MyComponent {
    constructor (props) {
        super(props);
        props.refer.current = this;


        this.state = {
            destroyedReasons: [
                {id: '', text: '...'},
                ...props.base.destroyedReasons.map(item => {
                    return {id: item.id, text: item.name};
                })
            ],
            sectionReturnReasons: [
                {id: '', text: '...'},
                ...props.base.sectionReturnReasons.map(item => {
                    return {id: item.id, text: item.name};
                })
            ],
            submit: 'ثبت',
            error: false,
            fields: {}
        };

        this.ref = {
            modal: React.createRef(),
            submit: React.createRef(),
            cancelOutgoingType: React.createRef(),
            sectionReturnReasonId: React.createRef(),
            destroyedReasonId: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        cancelOutgoingType: x => Boolean(x) || 'نوع درخواست انتخاب نشده است.',
        destroyedReasonId: x => this.state.fields?.cancelOutgoingType != 3 || Boolean(x && x[0].id) || 'علت امحا انتخاب نشده است.',
        sectionReturnReasonId: x => ![2, 3].includes(this.state.fields?.cancelOutgoingType) || Boolean(x && x[0].id) || 'علت عودت انتخاب نشده است.',
    };

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        const {state} = this;

        return state.submit !== nextState.submit ||
            state.error !== nextState.error ||
            state.fields !== nextState.fields;
    }

    componentDidMount () {

    }

    render () {
        const {state} = this;

        return <Modal ref={this.ref.modal}
                      name={'ModalHospitalOutgoingCancel'}
                      size={'medium'}
                      error={state.error}
                      title={'لغو ارسال / عودت فرآورده '}>
            <ModalContent>
                <div className={'dis-f'}>
                    <Input className={'pad-4 fb-10 fb-2x-20'} label={'گروه خونی'} readOnly={true} direction={'ltr'} value={state?.data?.productBloodGroupStr}/>
                    <Input className={'pad-4 fb-10 fb-2x-20'} label={'نوع فرآورده'} readOnly={true} value={state?.data?.productTypeStr}/>
                    <Input className={'pad-4 fb-10 fb-2x-20'} label={'شماره فرآورده'} readOnly={true} value={state?.data?.productNumber}/>
                    <Input className={'pad-4 fb-10 fb-2x-20'} label={'تاریخ انقضا'} readOnly={true} value={moment(state?.data?.expireDateTime).format('jYYYY-jMM-jDD')}/>
                    <Separator/>
                    <ValidationSpot ref={this.ref.cancelOutgoingType} label={'نوع درخواست'} className="dis-f fb-20" validation={this.validations.cancelOutgoingType}>
                        {Perms().BLOOD_BANK_OUTGOING.CANCEL && <Radio label={'لغو ارسال'} checked={state?.fields?.cancelOutgoingType == 1} onChange={this.setField.bind(this, 'cancelOutgoingType', 1)}/>}
                        {Perms().BLOOD_BANK_OUTGOING.RETRIEVE_TO_BLOOD_BANK && <Radio label={'عودت به بانک خون'} checked={state?.fields?.cancelOutgoingType == 2} onChange={this.setField.bind(this, 'cancelOutgoingType', 2)}/>}
                        {Perms().BLOOD_BANK_OUTGOING.CANCEL && Perms().BLOOD_BANK_OUTGOING.RETRIEVE_TO_BLOOD_BANK && <Radio label={'عودت و امحا'} checked={state?.fields?.cancelOutgoingType == 3} onChange={this.setField.bind(this, 'cancelOutgoingType', 3)}/>}
                        {[2, 3].includes(this.state.fields?.cancelOutgoingType) && <Select ref={this.ref.sectionReturnReasonId} className={'pad-4 fb-10'} label={'علت عودت فرآورده'} options={state.sectionReturnReasons} value={state?.fields?.sectionReturnReasonId} onChange={this.setField.bind(this, 'sectionReturnReasonId')} validation={this.validations.sectionReturnReasonId}/>}
                        {state?.fields?.cancelOutgoingType == 3 && <Select ref={this.ref.destroyedReasonId} className={'pad-4 fb-10'} label={'علت امحا فرآورده'} options={state.destroyedReasons} value={state?.fields?.destroyedReasonId} onChange={this.setField.bind(this, 'destroyedReasonId')} validation={this.validations.destroyedReasonId}/>}
                    </ValidationSpot>
                    <div className={'fb-20'} style={{color: 'var(--goo-red)', fontSize: 13}}>
                        {state?.fields?.cancelOutgoingType == 1 && <p>در صورت اشتباهات کاربری و یا عودت قبل از نیم ساعت، می بایست از این گزینه استفاده گردد تا فرآورده در آمار عودتی‌ها نبوده و به موجودی اضافه گردد.</p>}
                        {state?.fields?.cancelOutgoingType == 2 && <p>فرآورده موردنظر به موجودی بانک خون اضافه خواهد شد و در آمار عودتی قابل مشاهده خواهد شد.</p>}
                        {state?.fields?.cancelOutgoingType == 3 && <p>فرآورده موردنظر از چرخه بانک خون حذف شده و به لیست فرآورده‌های امحا شده اضافه می گردد و در آمار عودتی نیز قابل مشاهده می شود. (توجه: فرآورده امها شده، در برنامه قابل استفاده نمی باشد.)</p>}
                    </div>
                </div>
            </ModalContent>
            <ModalControls>
                <Button refer={this.ref.submit} className={'mar-4'} theme={'yellow'} onClick={this.submitClickHandler.bind(this)}>{state.submit}</Button>
                <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
            </ModalControls>
        </Modal>;
    }

    submitClickHandler () {
        if (this.validate()) {
            const type = this.state.fields?.cancelOutgoingType;

            this.ref.submit.current.loading();
            this.setState({error: null});
            Hospital.cancelSentProduct({
                outcomingDetailId: this.state.data?.outcomingDetailId,
                cancelOutgoingType: type,
                sectionReturnReasonId: (this.state.fields?.sectionReturnReasonId || [])[0]?.id || null,
                destroyedReasonId: (this.state.fields?.destroyedReasonId || [])[0]?.id || null
            }).then(_ => {
                const message = {
                    1: 'با موفقیت لغو شد.',
                    2: 'با موفقیت عودت شد.',
                    3: 'با موفقیت عودت / امحا شد.'
                };
                new Notif(message[type]).show();
                this.ref.submit.current.loading(false);
                this.close(true);
            }).catch(message => {
                this.ref.submit.current.loading(false);
                this.setState({error: message});
            });
        }
    }

    open (data, action) {
        this.setState({
            data,
            action,
            error: null,
            fields: {}
        });

        this.ref.modal.current.open();
    }

    close (success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    fieldWillUpdate (keys, value, currentFields, nextFields) {
        switch (keys[0]) {
            case 'cancelOutgoingType':
                if (value === 2 || value === 1)
                    delete nextFields.destroyedReasonId;
                if (value === 1)
                    delete nextFields.sectionReturnReasonId;
                this.ref.cancelOutgoingType.current.validate(nextFields?.cancelOutgoingType);
                break;
            default:
        }
    }

    validate () {
        let validate;

        validate = Tool.validate([this.ref.cancelOutgoingType, this.state.fields?.cancelOutgoingType]);
        if (this.state.fields?.cancelOutgoingType === 2) {
            validate = Tool.validate(this.ref.sectionReturnReasonId);
        }
        if (this.state.fields?.cancelOutgoingType === 3) {
            validate = Tool.validate(this.ref.destroyedReasonId,
                this.ref.sectionReturnReasonId);
        }

        console.log(validate);
        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base
    };
};

export default connect(mapStateToProps)(ModalHospitalOutgoingCancel);